/**
 * Generates a SQL query that lists all columns of a given table
 * using PostgreSQL system catalogs.
 */
export function list_columns(table: string): string {
  return `
    SELECT
    attname as field_name,
        typname as field_type

    FROM
    pg_namespace, pg_attribute, pg_type, pg_class

    WHERE
    pg_type.oid = atttypid AND
    pg_class.oid = attrelid AND
    relnamespace = pg_namespace.oid AND
    attnum >= 1 AND
    relname = '${table}'
        `;
}
